import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, BoxProps } from '@mui/material';
import useSettings from 'src/hooks/useSettings';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
    mini?: boolean;
    outerSx?: BoxProps['sx'];
    disableLink?: boolean;
    width?: any;
}

export default function ReachLinkLogo({
    mini = false,
    outerSx = { display: 'inline-flex', justifyContent: 'center' },
    disableLink = false,
    width = '100%',
}: Props) {
    const { themeMode } = useSettings();

    let src = '';
    if (mini) {
        src = '/favicon/Reachlink_Favicon.svg';
    } else {
        src =
            themeMode === 'light'
                ? '/favicon/Reachlink_Logo_VF_B.svg'
                : '/favicon/Reachlink_Logo_VF_W.svg';
    }

    const logo = (
        <Box sx={outerSx}>
            <img
                src={src}
                style={{
                    cursor: disableLink ? 'default' : 'pointer',
                    width,
                }}
                alt="ReachLink Logo"
            />
        </Box>
    );

    if (disableLink) {
        return <>{logo}</>;
    }

    return <RouterLink to="/auth/login">{logo}</RouterLink>;
}
